const _ = require("lodash");
const React = require("react");

const AssetsUtil = require("./AssetsUtil");

const OpsUser = require("../vault/OpsUser");
const OpsBlock = require("../vault/OpsBlock");
const SetButton = require("../view/SetProgressButton");
const BarLegend = require("../view/BarLegend");
const TopBarUser = require("../view/TopBarUser");
const WonkyButton = require("../view/WonkyButton");
const BlueLabel = require("../view/BlueLabel");

const OpsLab = require("../../lab/vault/OpsLab");
const LabUtil = require("../../../shared/LabUtil");
const TheaterPlayer = require("../../theater/TheaterPlayer");
const ChapterPathFindMyAvatarButton = require("../../trainer/reactView/ChapterPathFindMyAvatarButton");

const GradeChapter = require("../../../shared/GradeChapter");

const {
	inlineIcon,
	detailIcon,
	starBar,
	screenshot,
	sliderTab,
} = require("./CopyShared");

const sliderComponent = function(styles, gradeNumber, demo, userInfo) {
	const isAdminOrTeacher =
		OpsUser.hasAoPSRole(userInfo.user) || OpsUser.hasTeacherRole(userInfo.user);
	const text = (
		<span>
			<p>
				You can click the tab in the top-left to open the Beast Academy Play
				List and navigate to any Lesson, Reading, or Video.
			</p>
		</span>
	);
	const tab = sliderTab(styles, gradeNumber, text, demo, isAdminOrTeacher);
	return <div>{tab}</div>;
};

const getGradeNumber = userInfo => {
	const sequenceData = OpsUser.getSequenceDataFromUser(
		_.get(userInfo, "user", {})
	);
	return _.get(sequenceData, "gradeNumber");
};

/*
   Info on Playlist slider only shows for students on parent accounts
   (not school students, who see an Assignments binder/HW icon instead of the Playlist)
*/

const showSlider = function(styles, userInfo) {
	const gradeNumber = getGradeNumber(userInfo);
	const {demo} = userInfo?.page;
	const isSchoolStudent = OpsUser.isSchoolStudent(userInfo.user);
	return isSchoolStudent
		? ""
		: sliderComponent(styles, gradeNumber, demo, userInfo);
};

const blueButton = function(styles, type, opts = {}, overrideClass) {
	const outerClass = overrideClass ? overrideClass + "Outer" : type + "Outer";
	const innerClass = overrideClass ? overrideClass + "Inner" : type + "Inner";
	return (
		<div className={styles[outerClass]}>
			<div className={styles[innerClass]}>
				<WonkyButton
					buttonType={type}
					className={styles[type + "Button"]}
					isNonInteractive={true}
					noShadow={true}
					{...opts}
				/>
			</div>
		</div>
	);
};

const setButton = function(styles, opts, containerDims, text) {
	const cellSize = Math.max(35, containerDims.width / 25);
	const button = (
		<div className={styles.setButton}>
			<SetButton
				{...opts}
				containerDims={containerDims}
				cellSize={cellSize}
				noPointerEvents={true}
			/>
		</div>
	);
	if (text) {
		return (
			<div className={styles.outer}>
				{button}
				{text}
			</div>
		);
	} else {
		return <div className={styles.singleButton}>{button}</div>;
	}
};

const getHome = function(styles, userInfo) {
	const demo = userInfo.page.demo;
	const title = "Welcome to Beast Academy!";
	const progressBar = demo ? null : (
		<div>
			<p>
				{`The middle of the top bar keeps you updated on your progress in Beast Academy. Right now, you are level ${
					userInfo.level
				}, and you have earned ${
					userInfo.xp
				} points toward level ${userInfo.level + 1}.`}
			</p>
		</div>
	);
	const user = _.get(userInfo, "user", {});
	const canViewLeaderboards = OpsUser.canViewLeaderboards(user);
	const content = (
		<div className={styles.scrollContent}>
			<p>Let's take a look at the navigation at the top of the screen first.</p>
			<br />
			{detailIcon(
				styles,
				AssetsUtil.getButton("bell"),
				<span>
					<b>Class:</b> The Classroom is where you can play through lessons in
					each chapter to earn Stars and Trophies.
				</span>
			)}
			<br />
			{detailIcon(
				styles,
				AssetsUtil.getButton("book"),
				<span>
					<b>Library:</b> The Library has the online Beast Academy Guide books
					for you to read!
				</span>
			)}
			<br />
			{detailIcon(
				styles,
				AssetsUtil.getButton("projector"),
				<span>
					<b>Theater:</b> The Theater has videos in each chapter for you to
					watch!
				</span>
			)}
			<br />
			{!canViewLeaderboards || demo
				? null
				: detailIcon(
						styles,
						AssetsUtil.getButton("leaderboards"),
						<span>
							<b>Leaderboards:</b> The leaderboards show rankings and statistics
							for BA Online users, updated once daily.
						</span>
				  )}
			{!canViewLeaderboards || demo ? null : <br />}
			{detailIcon(
				styles,
				AssetsUtil.getButton("help"),
				<span>
					<b>Help:</b> The Help menu gives useful information about the page you
					are on.
				</span>
			)}
			<br />
			{detailIcon(
				styles,
				AssetsUtil.getButton("settings"),
				<span>
					<b>Settings:</b> The Settings allow you to adjust gameplay basics like
					sounds and music.
				</span>
			)}
			{showSlider(styles, userInfo)}
			<br />
			{progressBar}
			<p>When you are done for the day, you can sign out in the top right.</p>
			<div className={styles.centered}>
				<div className={styles.topbarWrapper}>
					<img
						className={styles.topbarBg}
						src={AssetsUtil.getTrainerElement("ba-top-bar")}
					/>
					<TopBarUser
						className={styles.topbarUser}
						isStatic={true}
						user={userInfo.user}
						page={{name: "home.main"}}
						demo={demo}
					/>
				</div>
			</div>
			<br />
		</div>
	);
	return {title, content};
};

const getChapter = function(styles, userInfo) {
	const page = userInfo.page;
	const {gradeNumber, chapterIndex, demo} = page;
	const chapterNumber = chapterIndex + 1;
	const nextChapterNumber = chapterNumber === 12 ? 1 : chapterNumber + 1;
	const prevChapterNumber = chapterNumber === 1 ? 12 : chapterNumber - 1;

	const getFindMyAvatarIcon = () => (
		<ChapterPathFindMyAvatarButton
			avatar={userInfo.avatar}
			demo={!!demo}
			user={userInfo.user}
			className={styles.detailIcon}
			disabled={true}
		/>
	);

	const title = demo
		? "Welcome to the Classroom!"
		: "Welcome to the Chapter Page!";
	const navigationText = demo ? (
		<div>
			<p>
				You are currently in the classroom. From here, you can see a selection
				of lessons.
			</p>
		</div>
	) : (
		<div>
			{`You are currently in Beast Academy Level ${gradeNumber}, Chapter ${chapterIndex +
				1}: ${GradeChapter.getChapterName(gradeNumber, chapterIndex + 1)}.`}
			<p>
				From here, you can see the lessons in this chapter or move to another
				chapter.
			</p>
			<div>
				{detailIcon(
					styles,
					AssetsUtil.getButtonChapterCircle(prevChapterNumber),
					<span>
						<b>Previous Chapter:</b> The button at the beginning of the hallway
						takes you to the previous chapter.
					</span>,
					true
				)}
				<br />
				{detailIcon(
					styles,
					AssetsUtil.getButtonChapterCircle(nextChapterNumber),
					<span>
						<b>Next Chapter:</b> The button at the end of the hallway takes you
						to the next chapter (you may need to scroll to the far right).
					</span>,
					true
				)}
				<br />
				{detailIcon(
					styles,
					AssetsUtil.getButtonCircle("index"),
					<span>
						<b>View All Chapters:</b> You can jump to any chapter from the
						chapter menu.
					</span>
				)}
				<br />
				{detailIcon(
					styles,
					getFindMyAvatarIcon(),
					<span>
						<b>Find My Avatar:</b> If you lose your avatar in the hallway click
						this icon to make it jump! This button is found in the bottom right
						hand corner of the hallway.
					</span>
				)}
				<br />
			</div>
			<p>
				Once you find a chapter you want to work on, you can click on a lesson
				to get started!
			</p>
		</div>
	);

	const replayabilityText = demo ? null : (
		<p>
			You can replay most lessons at least three times with different problems
			each time!
		</p>
	);

	const demoReplayabilityText = demo ? (
		<p>
			With an actual subscription, you can replay most lessons at least three
			times, with different problems each time!
		</p>
	) : null;

	const getHWContent = () => {
		const isSchoolStudent = OpsUser.isSchoolStudent(userInfo.user);
		const isAcademyUser = OpsUser.isAcademyUser(userInfo.user);

		if (!isSchoolStudent) {
			return null;
		}

		let incompleteText =
			"Lessons with a red binder clip icon have been assigned by your teacher and are not complete yet.";
		let completeText =
			"Lessons with a green binder clip icon have been assigned by your teacher and are completed.";
		if (isAcademyUser) {
			incompleteText = `Lessons with a red "HW" icon have been assigned by your teacher and are not complete yet.`;
			completeText = `Lessons with a green "HW" icon have been assigned by your teacher and are completed.`;
		}

		return (
			<React.Fragment>
				{detailIcon(
					styles,
					AssetsUtil.getHWIcon(isAcademyUser),
					<span>
						<b>Incomplete assignment:</b> {incompleteText}
					</span>
				)}
				<br />
				{detailIcon(
					styles,
					AssetsUtil.getHWIcon(isAcademyUser, true),
					<span>
						<b>Complete assignment:</b> {completeText}
					</span>
				)}
				<br />
			</React.Fragment>
		);
	};

	return {
		title,
		content: (
			<div className={styles.scrollContent}>
				{navigationText}
				{demoReplayabilityText}
				{detailIcon(
					styles,
					AssetsUtil.getButtonCircle("monster"),
					<span>
						<b>Enrichment:</b> Upstairs lessons with a monster icon are
						enrichment lessons that go beyond what is typically taught in most
						classrooms. These are great for students who need a challenge or
						want to learn a new topic.
					</span>
				)}
				<br />
				{detailIcon(
					styles,
					AssetsUtil.getButtonCircle("upstairs"),
					<span>
						<b>Upstairs:</b> Go upstairs to access enrichment lessons.
					</span>
				)}
				<br />
				{detailIcon(
					styles,
					AssetsUtil.getButtonCircle("downstairs"),
					<span>
						<b>Downstairs:</b> Go downstairs to return to the main floor.
					</span>
				)}
				<br />
				{getHWContent()}
				<p>
					As you finish lessons, the lesson buttons will show your progress.
				</p>
				<div>
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("locked"),
						<span>
							<b>Locked:</b> This icon will indicate that the material is
							locked. To find out why the material is locked, click on the icon.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("bell"),
						<span>
							<b>Unlocked Lesson:</b> This is an unlocked available lesson with
							no progress.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("bell-partial-progress"),
						<span>
							<b>Partial Progress:</b> As you make progress on a Lesson, the
							outer ring will turn gold.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("1-star"),
						<span>
							<b>Completed Lesson:</b> A check mark indicates a completed
							lesson.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButtonCircle("3-star"),
						<span>
							<b>Stars:</b> The number of stars in your completed lesson shows
							how many stars you have earned on your best attempt.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getTrainerIcon("trophy"),
						<span>
							<b>Available Trophy Problem:</b>{" "}
							{
								"If you earn at least 1 star, you might unlock a trophy problem!"
							}{" "}
							Click the trophy icon to try the problem!
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getTrainerIcon("trophy", true),
						<span>
							<b>Trophy:</b> When you complete a trophy problem, you earn its
							trophy!
						</span>
					)}
					<br />
				</div>
				{replayabilityText}
				{showSlider(styles, userInfo)}
				<br />
			</div>
		),
	};
};

const getProblem = function(styles, userInfo, containerDims) {
	const {block, page} = userInfo;
	const {demo, gradeNumber} = page;
	const isTrophy = _.get(page, "problemIndex") === "trophy";

	const introText = demo ? (
		<p>
			When you're playing these lessons as a subscriber, the middle of the top
			bar will show you your progress toward earning stars for the lesson.
		</p>
	) : (
		<p>
			In the middle of the top bar, you can see your progress toward earning
			stars for the lesson.
		</p>
	);
	const chapterButtonText = (
		<p>
			Click the{" "}
			{inlineIcon(
				styles,
				AssetsUtil.getButtonChapterCircle(page.chapterIndex + 1)
			)}{" "}
			chapter button to the left of the lesson title to return to the chapter
			screen.
		</p>
	);
	const guideBookText = demo ? null : (
		<p>
			Most lessons have corresponding reading in the Guide Book. Click the{" "}
			{inlineIcon(styles, AssetsUtil.getButtonCircle("bookmark"))} button to the
			right of the lesson title to open the Guide Book section that best matches
			the lesson you are on.
		</p>
	);

	const readAloudText =
		gradeNumber !== 2 ? null : (
			<p>
				Some problems have a read-aloud option. Click the{" "}
				{inlineIcon(styles, AssetsUtil.getGeneralIcon("read-aloud-play"))} in
				the upper-right of the problem to hear the words read aloud. We'll
				continue to add the read-aloud option to more problems as we train our
				robot how to read more math expressions!
			</p>
		);

	const sliderContent = showSlider(styles, userInfo);

	const standardInfo = {
		title: "Welcome to the Lesson Page!",
		content: (
			<div className={styles.scrollContent}>
				You are currently in a Lesson called{" "}
				<b>{_.get(block, "model.displayName")}</b>.{introText}
				<div>
					{starBar(
						styles,
						4,
						"No stars yet. Keep solving problems to earn stars!"
					)}
					<br />
					{starBar(
						styles,
						6,
						"1 star earned. If your progress looks like this when you finish the lesson, you will earn 1 star."
					)}
					<br />
					{starBar(
						styles,
						8,
						"2 stars earned. If your progress looks like this when you finish the lesson, you will earn 2 stars."
					)}
					<br />
					{starBar(
						styles,
						10,
						"Fill the progress bar in a lesson to earn 3 stars."
					)}
				</div>
				{chapterButtonText}
				<p>
					If the lesson you are on has a video set, a{" "}
					{inlineIcon(styles, AssetsUtil.getButtonCircle("play"))} button will
					appear to the right of the lesson title. Click the{" "}
					{inlineIcon(styles, AssetsUtil.getButtonCircle("play"))} to watch the
					video(s) for this lesson.
				</p>
				{guideBookText}
				{readAloudText}
				<div>
					You can switch between problems by clicking on the circles under the
					lesson title. The larger circle lets you know which problem you are
					currently working on.
					<br />
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 1,
							isCorrect: true,
							selectable: true,
							isComplete: true,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 2,
							isCorrect: true,
							selectable: true,
							isComplete: true,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 3,
							isCorrect: false,
							selectable: true,
							isComplete: true,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 4,
							isCorrect: true,
							selectable: true,
							isComplete: true,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 5,
							isCorrect: true,
							selectable: true,
							isComplete: true,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 0,
							problemNumber: 6,
							selectable: true,
							isActive: true,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 0,
							problemNumber: 7,
							selectable: false,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 0,
							problemNumber: 8,
							selectable: false,
						},
						containerDims
					)}
				</div>
				<br />
				<div>
					{setButton(
						styles,
						{
							problemNumber: 1,
							selectable: false,
						},
						containerDims,
						<span>
							<b>Locked:</b> You have not unlocked this problem yet.
						</span>
					)}
					<br />
					{setButton(
						styles,
						{
							problemNumber: 1,
							selectable: true,
						},
						containerDims,
						<span>
							<b>Unanswered.</b> You have not answered this problem yet.
						</span>
					)}
					<br />
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 1,
							isCorrect: true,
							selectable: true,
							isComplete: true,
						},
						containerDims,
						<span>
							<b>Correct!</b> You answered this problem correctly!
						</span>
					)}
					<br />
					{setButton(
						styles,
						{
							percentComplete: 0.5,
							problemNumber: 1,
							selectable: true,
						},
						containerDims,
						<span>
							<b>In Progress.</b> Your first answer was incorrect, but you get
							another try.
						</span>
					)}
					<br />
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 1,
							isCorrect: false,
							selectable: true,
							isComplete: true,
						},
						containerDims,
						<span>
							<b>Incorrect.</b> This problem was not answered correctly, and you
							don't get any more tries.
						</span>
					)}
					<br />
				</div>
				<p>
					On the left side of the page, you can find the drawing tools. These
					tools can be used to make notes and sketch your work, but marks you
					make with the drawing tools will not count as part of your answer.
				</p>
				<div>
					{detailIcon(
						styles,
						AssetsUtil.getButton("pencil"),
						<span>
							<b>Draw:</b> Click the pencil to start or stop drawing.
						</span>,
						true
					)}
					{detailIcon(
						styles,
						AssetsUtil.getButton("eraser"),
						<span>
							<b>Erase:</b> Click the eraser to start or stop erasing your
							pencil marks.
						</span>,
						true
					)}
				</div>
				<p>
					Every lesson begins with instructions. After you have closed the
					instructions, you can view them again by clicking the{" "}
					{inlineIcon(styles, AssetsUtil.getButton("info-black"))} on the right
					side of the lesson screen.
				</p>
				<p>
					You can use the keyboard at the bottom of the problem screen to type,
					or use your computer keyboard. Only the keys that are on the displayed
					keyboard can be used to type an answer. Some lessons don't require a
					keyboard at all.
				</p>
				<p>
					Some lessons have an extra-challenging trophy problem that you can
					unlock by earning 3 stars in the lesson.
				</p>
				{sliderContent}
			</div>
		),
	};

	const trophyInfo = {
		title: "Trophy problems are tough!",
		content: (
			<div>
				<p>
					You are playing the Trophy Problem for the{" "}
					<b>{_.get(block, "model.displayName")}</b> lesson.
				</p>
				<p>
					Trophy problems are extra-challenging problems that you earn by
					3-starring lessons.
				</p>
				<p>
					Unlike other problems, you get unlimited attempts at a Trophy problem.
				</p>
				<p>
					These are problems that could take a long time to solve! Here are some
					strategies we recommend if you're feeling stuck:
				</p>
				<ul className={styles.list}>
					<li>
						Review the problems and solutions in the lesson. Look for strategies
						that could help with the trophy problem.
					</li>
					<li>
						Talk to someone. Sharing your thoughts and ideas out loud can lead
						to a breakthrough.
					</li>
					<li>
						Take a break. Coming back to a problem with fresh eyes can make a
						big difference.
					</li>
				</ul>
				<p>
					Remember, these problems are supposed to be difficult! If they were
					easy, they wouldn't be nearly as rewarding when you solve them.
				</p>
				<p>Have fun!</p>
			</div>
		),
	};

	return isTrophy ? trophyInfo : standardInfo;
};

const getLabProblem = function(styles, userInfo, containerDims) {
	const {labBlock, page} = userInfo;
	const {typeID} = page;
	const typeName = OpsLab.getTypeNameFromID(typeID);
	const title = "Welcome to the Puzzle Page!";

	return {
		title,
		content: (
			<div className={styles.scrollContent}>
				<p>
					You are currently in a puzzle set called{" "}
					<b>{_.get(labBlock, "model.displayName")}</b> in the {typeName} puzzle
					type.
				</p>
				<p>
					Every puzzle type begins with instructions. After you have closed the
					instructions, click the{" "}
					{inlineIcon(styles, AssetsUtil.getButton("info-black"))} on the right
					side of the screen to view them again.
				</p>
				<p>
					On the left side of the page, you can find the drawing tools. These
					tools can be used to make notes and sketch your work, but marks you
					make with the drawing tools will not count as part of your answer.
				</p>
				<div>
					{detailIcon(
						styles,
						AssetsUtil.getButton("pencil"),
						<span>
							<b>Draw:</b> Click the pencil to start or stop drawing.
						</span>,
						true
					)}
					{detailIcon(
						styles,
						AssetsUtil.getButton("eraser"),
						<span>
							<b>Erase:</b> Click the eraser to start or stop erasing your
							pencil marks.
						</span>,
						true
					)}
				</div>
				<br />
				<div>
					You can switch between puzzles by clicking on the circles under the
					lesson title. The larger circle lets you know which puzzle you are
					currently working on.
					<br />
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 1,
							isCorrect: true,
							selectable: true,
							isComplete: true,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 2,
							isCorrect: true,
							selectable: true,
							isComplete: true,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 3,
							isCorrect: true,
							selectable: true,
							isComplete: true,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 4,
							isCorrect: true,
							selectable: true,
							isComplete: true,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 5,
							isCorrect: true,
							selectable: true,
							isComplete: true,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 0,
							problemNumber: 6,
							selectable: true,
							isActive: true,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 0,
							problemNumber: 7,
							selectable: false,
						},
						containerDims
					)}
					{setButton(
						styles,
						{
							percentComplete: 0,
							problemNumber: 8,
							selectable: false,
						},
						containerDims
					)}
				</div>
				<div>
					{setButton(
						styles,
						{
							problemNumber: 1,
							selectable: false,
						},
						containerDims,
						<span>
							<b>Locked:</b> You have not unlocked this problem yet.
						</span>
					)}
					<br />
					{setButton(
						styles,
						{
							problemNumber: 1,
							selectable: true,
						},
						containerDims,
						<span>
							<b>Unanswered.</b> You have not answered this problem yet.
						</span>
					)}
					<br />
					{setButton(
						styles,
						{
							percentComplete: 1,
							problemNumber: 1,
							isCorrect: true,
							selectable: true,
							isComplete: true,
						},
						containerDims,
						<span>
							<b>Correct!</b> You answered this problem correctly!
						</span>
					)}
				</div>
				<p>
					You can use the keyboard at the bottom of the problem screen to type,
					or use your computer keyboard. Only the keys that are on the displayed
					keyboard can be used to type an answer. Some puzzles don't require a
					keyboard at all.
				</p>
				<p>You have unlimited attempts to solve every puzzle.</p>
				<p>
					Click the{" "}
					{inlineIcon(
						styles,
						AssetsUtil.getButton("puzzle", "yellow"),
						"labLong"
					)}{" "}
					left of the name of the puzzle set to return to the Lab.
				</p>
				<br />
			</div>
		),
	};
};

const getTest = function(styles, userInfo, containerDims, inputData) {
	if (!inputData)
		return {
			title: "Do your best on this test!",
			content: null,
		};

	let testName = "BA";
	if (inputData.gradeNumber) {
		testName =
			`BA Level ${inputData.gradeNumber} ` +
			`${inputData.chapterIndex + 1}: ${inputData.name}`;
	} else if (inputData.forBookTest) {
		const bookHash = OpsBlock.getBookTestHashFromName(inputData.miscBlockName);
		testName = `BA Book ${bookHash}`;
	}

	const res = inputData.submitRestrictions;
	let part1Restrictions = `You can submit part 1 at any time. `;
	let part2Restrictions = `You can submit part 2 at any time. `;
	if (res.part1MinAnswered) {
		part1Restrictions =
			`You must save at least ${res.part1MinAnswered} ` +
			`answers before submitting part 1 of this test. `;
	}
	if (res.part2MinAnswered) {
		part2Restrictions =
			`You must save at least ${res.part2MinAnswered} ` +
			`answers before submitting part 2 of this test. `;
	}
	if (res.part1MinMinutes) {
		part1Restrictions =
			`You must spend at least ${res.part1MinMinutes} ` +
			`minutes on the test before submitting part 1. `;
	}
	if (res.part2MinMinutes) {
		part2Restrictions =
			`You must spend at least ${res.part2MinMinutes} ` +
			`minutes on the test before submitting part 2. `;
	}

	return {
		title: "Do your best on this test!",
		content: (
			<div className={styles.scrollContent}>
				<p>
					{inputData.forHistory
						? "You are looking at your most recent results in"
						: "You are currently taking"}{" "}
					the test for {testName}.
				</p>
				{inputData.forHistory ? null : (
					<p>
						All other areas of BA Online are locked until you submit your test.
						You cannot play lessons, watch videos, or read the Guide until you
						are finished.
					</p>
				)}
				{inputData.forHistory ? null : (
					<p>
						Ask your instructor if there are time limits or other requirements
						for this test.
					</p>
				)}
				<p>This test has two parts.</p>
				{inputData.forBookTest ? (
					<p>
						Part 1 has {inputData.part1Problems.length} questions.{" "}
						{part1Restrictions} After you submit part 1, you will be taken to
						part 2.
					</p>
				) : null}
				{!inputData.forBookTest ? (
					<p>
						Part 1 has {inputData.part1Problems.length} questions.{" "}
						{part1Restrictions} If you do well enough in part 1 you’ll earn one
						star, and you will be given the option to try part 2.
					</p>
				) : null}
				{inputData.forBookTest ? (
					<p>
						Part 2 has {inputData.part2Problems.length} questions.{" "}
						{part2Restrictions}
					</p>
				) : null}
				{!inputData.forBookTest ? (
					<p>
						Part 2 has {inputData.part2Problems.length} questions.{" "}
						{part2Restrictions} If you do well in part 2, you can earn up to 3
						stars.
					</p>
				) : null}
				You can answer the questions in each part in any order. After you have
				answered a test question, click the {blueButton(styles, "saveanswer")}{" "}
				button. This will save your answer and move you to the next problem. You
				can come back later to review or edit your answer.
				<br />
				<p>
					To switch problems, click a numbered circle under the lesson title.
					The large circle lets you know which problem you are working on. The
					yellow circles are problems where you saved an answer.
				</p>
				{screenshot(styles, "test-progress-bubbles")}
				<p>
					You can edit your saved answers at any time. If you make edits, the
					problem circle will change from yellow to gray and{" "}
					<b>you will need to save your answer again</b>.
				</p>
				To view a summary of your work on the test or to submit your work, click
				the {blueButton(styles, "testsummary")} button or the
				{/* book tests have no gradeNumber so let's just default to 3 */}
				{inlineIcon(
					styles,
					AssetsUtil.getBeastAvatar("headmaster", inputData.gradeNumber || 3)
				)}
				button. This will take you to a summary screen. From the summary screen,
				you can submit your answers or quit the test.
				<br />
				<p>
					During both parts of the test, we offer many of the same tools that
					are available in standard lessons.
				</p>
				<p>
					On the left side of the page, you can find the drawing tools. These
					tools can be used to make notes and sketch your work, but marks you
					make with the drawing tools will not count as part of your answer.
				</p>
				<div>
					{detailIcon(
						styles,
						AssetsUtil.getButton("pencil"),
						<span>
							<b>Draw:</b> Click the pencil to start or stop drawing.
						</span>,
						true
					)}
					{detailIcon(
						styles,
						AssetsUtil.getButton("eraser"),
						<span>
							<b>Erase:</b> Click the eraser to start or stop erasing your
							pencil marks.
						</span>,
						true
					)}
				</div>
				<p>
					You can view the test instructions by clicking the{" "}
					{inlineIcon(styles, AssetsUtil.getButton("info-black"))} on the right
					side of the screen.
				</p>
				<p>
					You can use the keyboard at the bottom of the problem screen to type,
					or use your computer keyboard. Only the keys that are on the displayed
					keyboard can be used to type an answer. Some lessons don't require a
					keyboard at all.
				</p>
				<br />
			</div>
		),
	};
};

const getLibrary = function(styles, userInfo) {
	const demo = userInfo.page.demo;
	const switchGradeText = demo ? null : (
		<p>You can see all of the chapters in a grade, or switch between grades.</p>
	);
	const navigationText = demo ? (
		<br />
	) : (
		<div>
			{detailIcon(
				styles,
				AssetsUtil.getButton("left"),
				<span>
					<b>Previous Grade:</b> The arrow on the left of the screen takes you
					to the previous grade.
				</span>,
				true
			)}
			<br />
			{detailIcon(
				styles,
				AssetsUtil.getButton("right"),
				<span>
					<b>Next Grade:</b> The arrow on the right of the screen takes you to
					the next grade.
				</span>,
				true
			)}
			<br />
			{detailIcon(
				styles,
				AssetsUtil.getButtonCircle("index"),
				<span>
					<b>View All Chapters:</b> You can jump to any chapter from the chapter
					menu.
				</span>
			)}
			<br />
		</div>
	);

	return {
		title: "Welcome to the Library!",
		content: (
			<div className={styles.scrollContent}>
				This is where you can read the illustrated Beast Academy Guide Books.{" "}
				<br />
				{switchGradeText}
				<div>
					{navigationText}
					{detailIcon(
						styles,
						AssetsUtil.getButton("checkmark"),
						<span>
							<b>Completed Chapter:</b> This lets you know that you have
							finished reading a chapter.
						</span>
					)}
					<br />
				</div>
				<p>
					If you exit a chapter without finishing, a progress bar will appear to
					let you know you are in the middle of a chapter.
				</p>
				<p>Click on any chapter to start reading.</p>
				{showSlider(styles, userInfo)}
			</div>
		),
	};
};

const getBook = function(styles, userInfo) {
	const demo = userInfo.page.demo;
	const sectionNavigationText = demo ? null : (
		<div>
			<p>
				You can use the right scroll bar to navigate between sections and
				chapters in the book.
			</p>
			<ul className={styles.listNoBullet}>
				<li>
					Click the{" "}
					{inlineIcon(styles, AssetsUtil.getButton("arrow-down"), null, "left")}{" "}
					on the scroll bar to open or close the scroll bar navigation and view
					section titles.
				</li>
				<li>
					The colors on the scroll bar show you where sections begin and end and
					are color-coded by teacher.
					<br />
				</li>
				<li>
					You can navigate to a different chapter using the arrows at the top of
					the scroll bar navigation..
				</li>
			</ul>
			<p>Click on any chapter to start reading.</p>
		</div>
	);

	return {
		title: "Welcome to the Guide Book!",
		content: (
			<div className={styles.scrollContent}>
				This is where you can read the illustrated Beast Academy Guide Books by
				chapter. <br />
				<p>
					To scroll through the book, you can use your mouse scroll wheel, click
					and drag, or touch and drag if you are using a touch screen. You can
					also scroll through the book using your keyboard's arrow keys, or the
					Page Up/Page Down keys.
				</p>
				<p>
					The three buttons on the left allow you to{" "}
					{inlineIcon(styles, AssetsUtil.getButton("zoom-in"))} zoom in,{" "}
					{inlineIcon(styles, AssetsUtil.getButton("zoom-out"))} zoom out, or
					return to the {inlineIcon(styles, AssetsUtil.getButton("book-blue"))}{" "}
					Library.
				</p>
				{sectionNavigationText}
				<p>
					Click the {inlineIcon(styles, AssetsUtil.getButton("arrow-down"))} at
					the top of the screen to open the main Navigation Bar.
					<br />
					Click the{" "}
					{inlineIcon(
						styles,
						AssetsUtil.getButton("arrow-down"),
						null,
						"up"
					)}{" "}
					to hide the Navigation Bar.
				</p>
				{showSlider(styles, userInfo)}
			</div>
		),
	};
};

const getProfile = function(styles, userInfo) {
	let homework;
	if (userInfo.hasHomework) {
		homework = (
			<p>
				In the <b>Homework</b> tab, you can view the weekly assigned homework.
			</p>
		);
	}
	return {
		title: "This is your Profile page!",
		content: (
			<div className={styles.scrollContent}>
				This is where you can view your progress. <br />
				<br />
				<div>
					{detailIcon(
						styles,
						AssetsUtil.getProfileIcon("star", true),
						<span>
							You earn stars by completing lessons. You can earn up to 3 stars
							on each lesson.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getGeneralIcon("icon-bonus-beast-yellow"),
						<span>
							A monster icon indicates an enrichment lesson. These lessons go
							beyond what is typically taught in most classrooms.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getTrainerIcon("trophy"),
						<span>
							Some lessons have trophy problems. Trophy problems are very
							challenging.{" "}
							{
								"You can unlock a lesson's trophy problem by earning at least 1 star in the lesson."
							}
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getProfileIcon("xp", true),
						<span>You earn experience points by solving problems.</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("lock-locked"),
						<span>
							Locked lessons and chapters can be unlocked by earning stars in
							previous lessons and chapters.
						</span>
					)}
					<br />
				</div>
				<p>
					Progress Bars give an overview of how you have done in each chapter.
					Bars are color-coded by grade and by the number of stars you have
					earned.
				</p>
				<div className={styles.barLegend}>
					<BarLegend gradeNumber={3} />
				</div>
				<p>
					In the <b>Profile</b> tab, you can view a snapshot of how you've done
					by teacher and by grade, along with your avatar, streaks, and activity
					totals.
				</p>
				{OpsUser.canAccessBeastbuilder(userInfo.user) ? (
					<p>Click the pencil icon next to your avatar to edit it.</p>
				) : null}
				<p>
					A streak is the number of days in a row that you have played for at
					least 5 minutes in BA Online.
				</p>
				<div className={styles.textImg}>
					<div>
						Use the arrows to change which grade you are viewing progress for.
					</div>
					{screenshot(styles, "level")}
				</div>
				<p>
					In the <b>Progress</b> tab, view details on your progress in Beast
					Academy Online.
				</p>
				<p>
					Click the arrow,{" "}
					{inlineIcon(
						styles,
						AssetsUtil.getButton("arrow-with-tail"),
						"sharpShadow"
					)}{" "}
					or{" "}
					{inlineIcon(
						styles,
						AssetsUtil.getButton("arrow-with-tail"),
						"sharpShadowRight",
						"right"
					)}
					, beside any grade or chapter to view or hide a more detailed report.
				</p>
				<p>
					In the <b>Activity</b> tab, you can view your Activity calendar, which
					gives you details on what you played each day.
				</p>
				{OpsUser.isSchoolStudent(userInfo.user) ? (
					<React.Fragment>
						<p>
							In the <b>Assignments</b> tab, you can view your progress on
							lessons that have been assigned by your teacher.
						</p>
						<br />
					</React.Fragment>
				) : null}
				<div>
					Use the buttons below the calendar to view minutes played{" "}
					{inlineIcon(styles, AssetsUtil.getProfileIcon("time", true))}, stars
					earned {inlineIcon(styles, AssetsUtil.getProfileIcon("star", true))},
					or experience points earned{" "}
					{inlineIcon(styles, AssetsUtil.getProfileIcon("xp", true))} on the
					calendar.
				</div>
				<p>
					Click any day of the calendar to see details about your progress on
					that day.
				</p>
				{homework}
			</div>
		),
	};
};

const getVideo = function(styles, userInfo) {
	const {theaterSet, page} = userInfo;
	const {demo} = page;

	const navigationText = demo ? null : (
		<div>
			<p>
				Click the{" "}
				{inlineIcon(
					styles,
					AssetsUtil.getButtonChapterCircle(page.chapterIndex + 1)
				)}{" "}
				chapter button to the left of the lesson title to return to the chapter
				screen.
			</p>
			<p>
				Click the{" "}
				{inlineIcon(styles, AssetsUtil.getButtonCircle("bell-theater"))} button
				to the right of the lesson title to leave the theater and play the
				lesson that corresponds to these videos.
			</p>
			<p>
				Click the {inlineIcon(styles, AssetsUtil.getButtonCircle("bookmark"))}{" "}
				to the right of the lesson title to open the Guide Book to the section
				that best matches the video set you are on.
			</p>
		</div>
	);
	const blockAttached = _.get(theaterSet, "blockModels", {});
	const sampleBlockAttached = _.sample(blockAttached);
	return {
		title: "Welcome to the Video Page!",
		content: (
			<div className={styles.scrollContent}>
				You are currently in the Video Set for{" "}
				<b>{_.get(sampleBlockAttached, "displayName")}</b>.
				<p>Move your mouse over the video to show the Video Control Bar.</p>
				<ul className={styles.listNoBullet}>
					<li>
						Click the{" "}
						{inlineIcon(
							styles,
							AssetsUtil.getTheaterIcon("play-triangle"),
							"theaterSmaller"
						)}{" "}
						to play the video and{" "}
						{inlineIcon(
							styles,
							AssetsUtil.getTheaterIcon("pause"),
							"theaterSmaller"
						)}{" "}
						to pause it.
					</li>
					<li>
						Control the volume with{" "}
						{inlineIcon(
							styles,
							AssetsUtil.getVolumeIcon("on"),
							"theaterSmaller"
						)}
						.
					</li>
					<li>
						Click{" "}
						{inlineIcon(
							styles,
							AssetsUtil.getTheaterIcon("cc-on"),
							"theaterLong"
						)}{" "}
						to turn closed captions on or off.
					</li>
					<li>
						Click{" "}
						{inlineIcon(
							styles,
							AssetsUtil.getTheaterIcon("fullscreen"),
							"theaterSmaller"
						)}{" "}
						to view the video in full screen.
					</li>
				</ul>
				<p>
					In Video Sets that have more than one video, you will see previews for
					each video at the bottom of the screen. Click on a preview to start
					watching that video.
				</p>
				{navigationText}
				{showSlider(styles, userInfo)}
			</div>
		),
	};
};

const getTheater = function(styles, userInfo) {
	const {page} = userInfo;
	const {gradeNumber, chapterIndex, demo} = page;
	const navigationText = demo ? (
		<p>This is where you can watch videos.</p>
	) : (
		<div>
			This is where you can watch videos.{" "}
			{`You are currently in Beast Academy Level ${gradeNumber}, Chapter ${chapterIndex +
				1}: ${GradeChapter.getChapterName(gradeNumber, chapterIndex + 1)}.`}
			<p>
				From here, you can see the videos in this chapter or move to another
				chapter.
			</p>
			<div>
				{detailIcon(
					styles,
					AssetsUtil.getButton("left"),
					<span>
						<b>Previous Chapter:</b> The arrow on the left of the screen takes
						you to the previous chapter.
					</span>,
					true
				)}
				<br />
				{detailIcon(
					styles,
					AssetsUtil.getButton("right"),
					<span>
						<b>Next Chapter:</b> The arrow on the right of the screen takes you
						to the next chapter.
					</span>,
					true
				)}
				<br />
				{detailIcon(
					styles,
					AssetsUtil.getButtonCircle("index"),
					<span>
						<b>View All Chapters:</b> You can jump to any chapter from the
						chapter menu.
					</span>
				)}
				<br />
			</div>
		</div>
	);

	return {
		title: "Welcome to the Theater!",
		content: (
			<div className={styles.scrollContent}>
				{navigationText}
				<p>
					Once you find the chapter you want, you can click on a video tile to
					start watching!
				</p>
				<div>
					{detailIcon(
						styles,
						AssetsUtil.getGeneralIcon("icon-bonus-beast-yellow"),
						<span>
							<b>Enrichment Videos:</b> Videos with a monster icon go beyond
							what is typically taught in most classrooms. These are great for
							when you need a challenge or if you want to learn a new topic.
						</span>
					)}
					<br />
					{detailIcon(
						styles,
						AssetsUtil.getButton("checkmark"),
						<span>
							<b>Completed Videos:</b> This lets you know that you have finished
							watching all videos for a lesson.
						</span>
					)}
				</div>
				<p>
					If you exit a set of videos without finishing, a progress bar will
					appear to let you know the video set is partially complete.
				</p>
				{showSlider(styles, userInfo)}
			</div>
		),
	};
};

const getBeastBuilder = function(styles, userInfo) {
	return {
		title: "Welcome to Beast Builder!",
		content: (
			<div className={styles.scrollContent}>
				This is where you can spend Beast Bucks on monster parts to create your
				own avatar.
				<br />
				<TheaterPlayer
					videoSetID={1}
					videoIndex={0}
					videoURL={AssetsUtil.getGeneralVideo("beast-tutorial")}
					position={0}
					disableFullScreen={true}
					skipLogging={true}
				/>
				<div>
					<div className={styles.subtitle}>Beast Parts</div>
					<p>
						The menu on the left lets you access various parts to build your
						monster.
					</p>
					{screenshot(styles, "bbPartShop")}
					{screenshot(styles, "bbBucks")}
					<p>
						You have a limited amount to spend on beast parts.
						<br />
						<b>Available</b> tells you how many Beast Bucks you have left to
						spend on beast parts.
						<br />
						<b>Total</b> is the total number Beast Bucks you have earned. <br />
						Earn more Beast Bucks by earning new stars and trophies in lessons!
					</p>
					<div>
						Click {inlineIcon(styles, AssetsUtil.getBeastBuilderIcon("head"))}{" "}
						for head parts:
						<br />
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("head", "eye"),
							<span>Eyes unlock at level 1.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("head", "mouth"),
							<span>Mouths unlock at level 5.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("head", "head"),
							<span>Heads unlock at level 14.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("head", "ear"),
							<span>Ears and Horns unlock at level 17.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("head", "hair"),
							<span>Hair unlocks at level 20.</span>
						)}
					</div>
					<br />
					<div>
						Click {inlineIcon(styles, AssetsUtil.getBeastBuilderIcon("body"))}{" "}
						for body parts:
						<br />
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("body", "body"),
							<span>Body shapes unlock at level 1.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("body", "leg"),
							<span>Legs unlock at level 8.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("body", "arm"),
							<span>Arms unlock at level 11.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("body", "tail"),
							<span>Tails unlock at level 23.</span>
						)}
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderIcon("body", "wing"),
							<span>Wings unlocks at level 26.</span>
						)}
						<br />
						<div>
							Click{" "}
							{blueButton(styles, "expand", {
								buttonText: "see more",
								buttonImageSrc: AssetsUtil.getTrainerIconButton("right"),
								buttonImageOnRight: true,
								noBorder: true,
							})}{" "}
							to view a larger grid of parts.
						</div>
						<br />
						<div>
							Click{" "}
							<BlueLabel className={styles.count} label="+" quadStyleNum={3} />{" "}
							to add a part to your beast.
						</div>
					</div>
				</div>
				<div className={styles.subtitle}>Editing Your Avatar</div>
				<div>
					<p>These action buttons are at the bottom of the screen:</p>
					<div>
						{detailIcon(
							styles,
							blueButton(styles, "selectall"),
							<span>Selects all parts of your current avatar.</span>
						)}
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderButton("undo"),
							<span>Undo last change.</span>,
							styles.bbButtonSquare
						)}
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderButton("redo"),
							<span>Redo the last change undone.</span>,
							styles.bbButtonSquare
						)}
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderButton("photo"),
							<span>
								Access your photo gallery to take a picture or update your
								profile photo.
							</span>,
							styles.bbButtonSquare
						)}
					</div>
					<p>
						Select any part by clicking on it or by clicking it in the layer
						menu. You can move a part anywhere inside the center circle.
					</p>
					<div>
						All changes you make in Beast Builder are saved automatically. If
						you leave Beast Builder and return, your monster will look the same
						as you left it. The{" "}
						<div className={styles.bbButtonInText}>
							{inlineIcon(styles, AssetsUtil.getBeastBuilderButton("photo"))}
						</div>{" "}
						lets you take a photo of your current beast or change your profile
						photo. You can save up to 6 photos in your gallery.
					</div>
					{screenshot(styles, "bbSingleSelectedPart")}
					<p>
						You can edit individual parts with the buttons on the corners of a
						selected part:
					</p>
					<div className={styles.tabOnly}>
						<div>
							{detailIcon(
								styles,
								AssetsUtil.getBeastBuilderButton("reflectv"),
								<span>Reflect (flip) the part across a vertical line</span>,
								styles.bbButtonSquare
							)}
						</div>
						<br />
						<div>
							{detailIcon(
								styles,
								AssetsUtil.getBeastBuilderButton("reflecth"),
								<span>Reflect (flip) the part across a horizontal line</span>,
								styles.bbButtonSquare
							)}
						</div>
						<br />
						<div>
							{detailIcon(
								styles,
								AssetsUtil.getBeastBuilderButton("rotate"),
								<span>Rotate (spin) the part</span>,
								styles.bbButtonSquare
							)}
						</div>
						<br />
						<div>
							{detailIcon(
								styles,
								AssetsUtil.getBeastBuilderButton("resize"),
								<span>Resize the part</span>,
								styles.bbButtonSquare
							)}
						</div>
						<br />
					</div>
					<p>
						If you have selected more than one part, you can reflect, rotate, or
						resize all of them at once.
					</p>
					<p>At the bottom of your screen:</p>
					<div className={styles.tabOnly}>
						<div>
							{blueButton(
								styles,
								null,
								{
									buttonImageSrc: AssetsUtil.getBeastBuilderButton("copy"),
									buttonImageSize: 2,
									noBorder: true,
									quadNum: 0,
								},
								"bottomButton"
							)}{" "}
							Make a copy of the part.
						</div>
						<br />
						<div>
							{blueButton(
								styles,
								null,
								{
									buttonImageSrc: AssetsUtil.getBeastBuilderButton("trash"),
									buttonImageSize: 2,
									noBorder: true,
									quadNum: 1,
								},
								"bottomButton"
							)}{" "}
							Delete the part.
						</div>
						<br />
						<div>
							{blueButton(
								styles,
								null,
								{
									buttonImageSrc: AssetsUtil.getBeastBuilderButton("palette"),
									buttonImageSize: 2,
									noBorder: true,
									quadNum: 2,
								},
								"bottomButton"
							)}{" "}
							Open the color selection tool.
							{screenshot(styles, "bbColorSelectTool")}
							<p>
								Click any color to choose it, and click the arrows to see more
								color options. Some parts cannot change color.
							</p>
						</div>
					</div>
				</div>
				<div className={styles.subtitle}>Layering</div>
				<div>
					<p>
						The layer menu on the right shows you how the parts of your monster
						are stacked.
					</p>
					<p>
						Select any part to change the layer. Parts that are behind other
						parts may not be visible. You can see and select any part of our
						monster in the layer menu, even if some parts are not visible.
					</p>
					{screenshot(styles, "bbSingleLayerPart")}
					<div>
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderButton("layerTop"),
							<span>Sends the part to the top layer.</span>,
							styles.bbButtonSquare
						)}
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderButton("layerUp"),
							<span>Sends the part up one layer.</span>,
							styles.bbButtonSquare
						)}
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderButton("layerDown"),
							<span>Sends the part down one layer.</span>,
							styles.bbButtonSquare
						)}
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getBeastBuilderButton("layerBottom"),
							<span>Sends the part to the bottom layer.</span>,
							styles.bbButtonSquare
						)}
					</div>
				</div>
				<br />
				<div className={styles.subtitle}>Keyboard Shorcuts</div>
				<p>
					If you are using a device with a keyboard, you can also use these
					shortcuts.
				</p>
				<div className={styles.tabOnly}>
					<b>Select All:</b> Ctrl-A (Windows) or Cmd-A (Mac)
					<br />
					Holding down Ctrl (Window) or Cmd (Mac) while clicking on individual
					parts will let you select multiple parts together.
					<br />
					<b>Undo:</b> Ctrl-Z (Windows) or Cmd-Z (Mac)
					<br />
					<b>Redo:</b> Ctrl-Y (Windows) or Shift-Cmd-Z (Mac)
					<br />
					<b>Delete selected part:</b> Delete or Backspace
					<br />
					<b>Send part up one layer:</b> Page Up
					<br />
					<b>Send part down one layer:</b> Page Down
					<br />
				</div>
			</div>
		),
	};
};

const getLabLobby = function(styles, userInfo) {
	const title = "Welcome to the Puzzle Lab!";

	const labTypesTableRows = LabUtil.getActiveTypeIDs().map(typeID => {
		const labType = OpsLab.getTypeNameFromID(typeID);
		return (
			<>
				<div
					style={{
						display: "flex",
					}}
				>
					{detailIcon(
						styles,
						AssetsUtil.getLabTypeImage(labType, false),
						"",
						true
					)}
					{labType}
				</div>
				<div
					style={{
						height: ".5rem",
					}}
				/>
			</>
		);
	});

	return {
		title,
		content: (
			<div className={styles.scrollContent}>
				<p>The Puzzle Lab is full of… you guessed it, puzzles!</p>
				<p>
					Each puzzle type has many puzzle sets you can play! Click on any
					puzzle type to find more information about it, including how to unlock
					it, and where to find more like it.
				</p>

				<p>
					Once you find an unlocked puzzle set you want to play, click it to get
					started!
				</p>
				<p>Good luck, and have fun!</p>
				<br />
				{labTypesTableRows}
				<br />
			</div>
		),
	};
};

const getLabType = function(styles, userInfo) {
	const page = userInfo.page;
	const {typeID} = page;
	const title = "Welcome to the Puzzle Lab!";
	const typeName = OpsLab.getTypeNameFromID(typeID);

	return {
		title,
		content: (
			<div className={styles.scrollContent}>
				<div>
					<p>{`You are currently looking at the ${typeName} puzzles.`}</p>
					<p>
						{"You can find information about this puzzle type at the bottom of the" +
							" page, including how to unlock it, and where to find more " +
							`${typeName} puzzles.`}
					</p>
					<p>
						Once you find an unlocked puzzle set you want to play, click it to
						get started!
					</p>
					<p>
						There are four difficulty levels for puzzle sets. In order of
						difficulty, they are:
					</p>
					<div>
						{detailIcon(
							styles,
							AssetsUtil.getCelestialImage("moon", true),
							<span>
								Moon sets offer a challenging introduction to each puzzle type.
							</span>
						)}
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getCelestialImage("comet", true),
							<span>
								Comet sets are for ambitious high-flyers ready to go beyond the
								moon.
							</span>
						)}
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getCelestialImage("planet", true),
							<span>
								Rocket science may be too easy for you if you can finish these
								planet level sets.
							</span>
						)}
						<br />
						{detailIcon(
							styles,
							AssetsUtil.getCelestialImage("galaxy", true),
							<span>
								You'll need out-of-this-world dedication to solve the galaxy
								level sets.
							</span>
						)}
						<br />
					</div>
					<p>Complete puzzle sets to unlock the more difficult ones.</p>
					<p>Good luck, and have fun!</p>
					<p>Click the back icon to return to the Puzzle Lab Lobby.</p>
					<br />
				</div>
			</div>
		),
	};
};

const makeLabCopyFunc = labType => {
	if (labType) {
		return getLabType;
	} else {
		return getLabLobby;
	}
};

module.exports = {
	"home.main": getHome,
	"trainer.chapter": getChapter,
	"trainer.problem": getProblem,
	"trainer.history": getProblem, //Show same info as problem page for now
	"profile.main": getProfile,
	"library.grade": getLibrary,
	"library.chapter": getBook,
	"theater.set": getVideo,
	"theater.chapter": getTheater,
	"lab.problem": getLabProblem,
	"beastbuilder.main": getBeastBuilder,
	makeLabCopyFunc,
	test: getTest,
};
